import React, { useEffect, useState } from "react"

import modStyl from './index.module.scss'
import { Option } from "../utils"

interface Props {
  value: string[]
  visible: boolean
  options: Option[]
  onConfirm: (value: string[])=> void
  onCancel: ()=> void
}

interface Crumb {
  label: string
  value: string
  active: boolean
  children: Option[]
}

const Cascader: React.FC<Props> = ({ options, visible, value, onConfirm, onCancel })=> {
  // 当前选择的
  const [current, setCurrent] = useState<Crumb>({
    active: true,
    label: '请选择',
    value: '0000',
    children: options
  })

  // 所有选择的
  const [crumbs, setCrumbs] = useState<Crumb[]>([])

  const handleClick = (value: string, label: string, children: Option[])=> {
    if (children.length > 0) {
      setCrumbs([...crumbs, {active: false, label, value, children}, {active: true, label: '请选择', value: '0000', children}])
      setCurrent({ label, value, children, active: false })
    } else {
      setCrumbs([...crumbs.splice(0, 1), {label, value, active: true, children}])
      setCurrent({ ...current, label, value })
    }
  }

  const handleCrumbChange = (childern: Option[], index: number)=> {
    if (index === 0) {
      setCrumbs([])
      setCurrent({
        active: true,
        label: '请选择',
        value: '0000',
        children: options
      })
    } else {
      setCrumbs([...crumbs.slice(0, index + 1)])
      setCurrent({
        active: true,
        label: '请选择',
        value: '0000',
        children: childern
      })
    }
  }

  const computedClassName = (value: string, disabled?: boolean)=> {
    const pieces = []
    if (disabled) {
      pieces.push(modStyl.disabled)
    }
    if (current.value === value) {
      pieces.push(modStyl.active)
    }
    return pieces.join(' ')
  }

  const handleConfirm = ()=> {
    onConfirm(crumbs.filter(({label})=> label !== '请选择').map(({label})=> label))
  }

  useEffect(()=> {
    if (value.length > 0) {
      const pieces: Crumb[] = []
      
      let target = options
      let item: Option | undefined
      for (let label of value) {
        item = target.find((t)=> t.label === label)
        if (item) {
          pieces.push({
            active: false,
            label: item.label,
            value: item.value,
            children: target || []
          })
          target = item.children || []
        }
      }

      pieces[pieces.length - 1].active = true

      setCrumbs(pieces)
      setCurrent(pieces[pieces.length - 1])
    } else {
      setCrumbs([])
      setCurrent({
        active: true,
        label: '请选择',
        value: '0000',
        children: options
      })
    }
  }, [value])
  
  if (!visible) {
    return null
  }

  return (
    <div onClick={onCancel} className={modStyl.wrapper}>
      <div onClick={(e)=> e.stopPropagation()} className={modStyl.container}>
        <div className={modStyl.header}>
          <button onClick={onCancel} type="button">取消</button>
          <button onClick={handleConfirm} className={modStyl.buttonConfirm} type="button">确定</button>
        </div>
        <div className={modStyl.crumbs}>
          {
            crumbs.length === 0 && (
              <button type="button" className={modStyl.active}>
                <span>请选择</span>
              </button>
            )
          }
          {
            crumbs.map(({active, label, value, children}, index: number)=> (
              <button className={active ? modStyl.active : ''} onClick={()=> handleCrumbChange(children, index)} key={value} type="button">
                <span>{label}</span>
              </button>
            ))
          }
        </div>
        <div className={modStyl.body}>
          <ul>
            {
              current.children.map(({disabled, label, value, children = []})=> (
                <li onClick={()=> handleClick(value, label, children)} key={value} className={computedClassName(value, disabled)}>
                  <span>{label}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"></path>
                  </svg>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Cascader
